import React, { useState } from "react";
import { Typography, Modal, Form, Input, Button, Select } from "antd";
import { swalNotification } from "../../../../../../components/alret/notificztion";
import { validationErrors } from "../../../../../../utils/Helpers";
import { getOrderDetailUnassignRider } from "../../../../../../services/orderManagement.service";

const {Text} = Typography;
const { Option } = Select;

const UNASSIGN_REASONS = [
  "Rider requested unassignment",
  "Rider not responding",
  "Technical issue",
  "Operational reassignment",
  "Duplicate order",
  "Other",
];

const ModalUnassignOrder = (props) => {
  const [MBtnLoading, setMBtnLoading] = useState(false);
  const [form] = Form.useForm();

  const handleOkOrder = async () => {
    try {
      setMBtnLoading(true);
      const values = await form.validateFields();
      const data = {
        orderId: props.OrderId,
        riderId: props.orderRiderID.id,
        reason: values.reason,
        comment: values.comment || null,
      };
      // console.log("data", data)
      const resp = await getOrderDetailUnassignRider(data);
      if (resp.data.code == 200){
        swalNotification(
          "Rider Unassign",
          resp.data.message,
          "success"
        );
      } else {
        swalNotification(
          "Rider Unassign",
          resp.data.message,
          "error"
        );
      }
    } catch (e) {
      validationErrors(e);
    } finally {
      setMBtnLoading(false);
      props.setvisible(false);
      props.postListsrefresh();
    }
  };
  const handleCancel = () => {
    form.resetFields();
    props.setvisible(false);
  };

  const agentId = props?.agentUser?.id ?? localStorage.getItem("user_id");
  const agentEmail = props?.agentUser?.email ?? "-";

  return (
    <Modal
      title={`Unassign Order ID #${props.OrderId}`}
      visible={props.visible}
      onCancel={handleCancel}
      footer={[
        <Button loading={MBtnLoading} onClick={handleCancel}>No</Button>,
        <Button loading={MBtnLoading} onClick={handleOkOrder}>Yes</Button>,
      ]}
    >
      <Text>Are you sure you want to Unassign order?</Text>
        {props.orderRiderID && props.orderRiderID.fullName ? (<>
          <Form.Item label="Current rider">{props.orderRiderID.fullName}</Form.Item>
        </>) : ("")}

      <Form
        form={form}
        layout="vertical"
        initialValues={{ reason: undefined, comment: "" }}
      >
        <Form.Item label="Agent ID">
          <Input value={agentId || "-"} disabled />
        </Form.Item>
        <Form.Item label="Agent Email">
          <Input value={agentEmail || "-"} disabled />
        </Form.Item>

        <Form.Item
          name="reason"
          label="Reason"
          rules={[{ required: true, message: "Please select a reason" }]}
        >
          <Select placeholder="Select reason">
            {UNASSIGN_REASONS.map((r) => (
              <Option key={r} value={r}>{r}</Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="comment"
          label="Comment"
          dependencies={["reason"]}
          rules={[
            ({ getFieldValue }) => ({
              validator(_, value) {
                if ((getFieldValue("reason") || "").toLowerCase() === "other") {
                  if (!value || value.trim().length < 3) {
                    return Promise.reject(new Error("Comment is required when reason is Other"));
                  }
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <Input.TextArea rows={3} placeholder="Optional (required for Other)" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalUnassignOrder;
